module.exports = __webpack_public_path__ + "img/orange-circle-table-2.96ade932.png";